import {
  GET_UNUSED_DEALERS,
  GET_UNUSED_DEALERS_FAILED,
  GET_UNUSED_DEALERS_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  getUnusedDealerError: null,
  getUnusedDealerLoading: false,
  getUnusedDealerMessage: null,
  getUnusedDealersData: [],
};

const getUnusedDealers = (state = initialState, action) => {
  switch (action.type) {
    case GET_UNUSED_DEALERS:
      return {
        ...state,
        getUnusedDealerLoading: true,
        getUnusedDealerError: null,
        getUnusedDealerMessage: null,
        getUnusedDealersData: [],
      };

    case GET_UNUSED_DEALERS_SUCCESSFUL:
      return {
        ...state,
        getUnusedDealerLoading: false,
        getUnusedDealerError: null,
        getUnusedDealerMessage: null,
        getUnusedDealersData: action.payload.data,
      };

    case GET_UNUSED_DEALERS_FAILED:
      return {
        ...state,
        getUnusedDealerLoading: false,
        getUnusedDealerError: action.payload.error,
        getUnusedDealerMessage: null,
        getUnusedDealersData: [],
      };

    default:
      return state;
  }
};

export default getUnusedDealers;